export enum EPaymentHistoryRoutes {
  PAYMENT_HISTORY = 'PaymentHistory',
  PAYMENT_HISTORY_DETAIL = 'PaymentHistory.Detail'
}
